import { Component, Input } from "@angular/core";

@Component({
    selector: "vsf-product-skeleton",
    templateUrl: "./product-skeleton.component.html",
})
export class ProductSkeletonComponent {
    @Input() count = 3;

    get skeletonItems(): number[] {
        return Array(this.count).fill(0);
    }
}

